import {
    REGISTRATION_MEMBER_ROUTE,
    CONTACT_US_ROUTE,
    CREATE_PASSWORD_ROUTE,
    LOGIN_ROUTE,
    RECORDING_DETAILS_ROUTE,
    VIEW_ROUTE,
    VIEW_WORK_ROUTE,
    INACTIVE_ROUTE,
    SIGN_UP_ROUTE,
    SIGN_UP_COMPLETE_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    NEW_USER_ROUTE,
    SEARCH_ROUTE,
    ACCESS_DENIED_ROUTE,
    UI_ROUTE,
    FORM_SEGMENT,
    PROFILE_ROUTE,
    QUESTIONNAIRE_ROUTE,
    REGISTRATION_SONGWRITER_ROUTE,
    SONGWRITER_ROUTE,
    SONGWRITER_SUB_ROUTES,
    NOTIFICATION_PREFERENCES_ROUTE,
} from '@App/navigation/route'
import rightsholderNavigation from '@App/navigation/rightsholder-navigation'

type ID = string | number

const Navigation = {
    home: {
        root: () => '/',
    },
    login: {
        root: () => `/${LOGIN_ROUTE}`,
        inactive: () => `/${LOGIN_ROUTE}?inactive`,
        handleInactive: () => `/${INACTIVE_ROUTE}`,
    },
    signUp: {
        root: () => `/${SIGN_UP_ROUTE}`,
    },
    signUpComplete: {
        root: () => `/${SIGN_UP_COMPLETE_ROUTE}`,
    },
    forgotPassword: {
        root: () => `/${FORGOT_PASSWORD_ROUTE}`,
    },
    createPassword: {
        root: (activatingCode: string) => `/${CREATE_PASSWORD_ROUTE}/${activatingCode}`,
    },
    newUser: {
        root: () => `/${NEW_USER_ROUTE}`,
    },
    search: {
        root: () => `/${SEARCH_ROUTE}`,
    },
    viewWork: {
        root: (workId: ID) => `/${VIEW_WORK_ROUTE}/${workId}`,
    },
    contactUs: {
        root: () => `/${CONTACT_US_ROUTE}`,
    },
    accessDenied: {
        root: () => `/${ACCESS_DENIED_ROUTE}`,
    },
    ui: {
        root: () => `/${UI_ROUTE}`,
    },
    recordingDetails: {
        root: (recordingId: ID) => `/${RECORDING_DETAILS_ROUTE}/${recordingId}`,
    },
    profile: {
        root: () => `/${PROFILE_ROUTE}`,
        changePassword: () => `/${PROFILE_ROUTE}/change-password`,
        songwriters: () => `/${PROFILE_ROUTE}#songwriters'`,
        rightsHolders: () => `/${PROFILE_ROUTE}#members'`,
        user: () => `/${PROFILE_ROUTE}#user`,
    },
    registrationRightsholder: {
        root: () => `/${REGISTRATION_MEMBER_ROUTE}`,
        form: () => `/${REGISTRATION_MEMBER_ROUTE}/${FORM_SEGMENT}`,
        questionnaire: () => `/${REGISTRATION_MEMBER_ROUTE}/${QUESTIONNAIRE_ROUTE}`,
    },
    registrationSongwriter: {
        root: () => `/${REGISTRATION_SONGWRITER_ROUTE}`,
    },
    rightholder: rightsholderNavigation,
    songwriter: {
        root: (id: ID) => `/${SONGWRITER_ROUTE}/${id}`,
        catalogBuilder: (id: ID) => `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.link}`,
        cowriterSearch: (id: ID) =>
            `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.cowriters.root}/${SONGWRITER_SUB_ROUTES.cowriters.search}`,
        myWriters: (id: ID) => `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.myWriters}`,
        catalog: {
            root: (id: ID) => `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.catalog.root}`,
            viewWork: (id: ID, workId: ID) => `/${SONGWRITER_ROUTE}/${id}/${VIEW_WORK_ROUTE}/${workId}/${VIEW_ROUTE}`,
            requestUpdateShares: (id: ID, workId: ID) =>
                `/${SONGWRITER_ROUTE}/${id}/${VIEW_WORK_ROUTE}/${workId}/request-update-shares`,
        },
        viewSearchedWork: (id: ID, workId: ID) => `/${SONGWRITER_ROUTE}/${id}/search/work/${workId}/${VIEW_ROUTE}`,
        matchingTool: (id: ID) => `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.matchingTool}`,
        matchingHistory: (id: ID) => `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.matchHistory.root}`,
        matchingHistoryViewSubmission: (id: ID, submissionId: ID) =>
            `/${SONGWRITER_ROUTE}/${id}/${SONGWRITER_SUB_ROUTES.matchHistory.root}/${submissionId}`,
    },
    notification: {
        preferences: () => `/${NOTIFICATION_PREFERENCES_ROUTE}`,
    },
}

export { ID }

export default Object.freeze(Navigation)
